export default "__VITE_ASSET__DneKfDAz__"